import {Component, OnDestroy} from '@angular/core';
import {Subject} from 'rxjs';

@Component({
  selector: 'app-mm',
  templateUrl: './mm.component.html',
  styleUrls: ['./mm.component.scss']
})

export class MmComponent implements OnDestroy {

  menuActive: boolean;

  // DESTROY SUBJECT
  onDestroy$: Subject<void> = new Subject<void>();

  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }

  // ********************************************************************************************************
  // UI
  // ********************************************************************************************************

  // EVENT LISTENERS
  onToggleMenu(): void {
    this.menuActive = !this.menuActive;
  }

}
